import { csHttp } from "./http";

export function csMyReferral(phone) {
  if (!phone) return Promise.reject(new Error("phone is required"));
  return csHttp.get(`/api/me/referral?phone=${encodeURIComponent(phone)}`);
}

